<template>
  <v-col>
    <v-card>
      <v-card-title>
        <a class="mr-3" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </a>
        Poi name: {{ poiRel.poi ? poiRel.poi.name : '' }}

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :to="`/poi/${poiRel.poi_id}`" target="_blank"
              fab x-small
              color="green"
              class="ml-3"
            >
              <v-icon>
                mdi-link-variant
              </v-icon>
            </v-btn>
          </template>
          go to poi
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <div>
          POI ID: {{ poiRel.poi_id }}
        </div>
        <div>
          POI Existing videos: {{ poiRel.poi ? poiRel.poi.commonvideodata_count : '' }}
        </div>
        <div>
          POI Existing slides: {{ poiRel.poi ? poiRel.poi.slidevideodata_count : '' }}
        </div>
        <div>
          Ambassador: {{ poiRel.ambassador ? poiRel.ambassador.login : '' }}
        </div>
        <div>
          Status:
          <amb-status-icon :status="poiRel.status" :statuses="statuses"></amb-status-icon>
        </div>

        <v-dialog
          v-model="poiMarkersDialog.show"
          max-width="80%"
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              small
            >
              Google map
            </v-btn>
          </template>
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text v-if="poiRel.id">
              <GoogleMapMarkers
                ref="poiMapMarkers"
                :items="[poiRel.poi]"
                :isVisible="true"
                :maxZoom="15"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="poiMarkersDialog.show=false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-divider class="my-3"></v-divider>

        <v-tabs
            v-model=pageTab
            grow
        >
          <v-tab>
            VIDEO
          </v-tab>
          <v-tab
              @click="bulkSetAdminViewed"
          >
            <v-badge
                color="pink"
                dot
                :value="newImages.length"
            >
              IMAGES
            </v-badge>
          </v-tab>
        </v-tabs>

        <v-tabs-items
            v-model="pageTab"
        >
          <v-tab-item>
            <div class="d-flex flex-wrap align-start mb-6">
              <amb-media-card
                  v-for="video in poiRel.videos"
                  :key="video.id"
                  :media="video"
                  :poi-status="poiRel.status"
                  :media-priorities="videoPriorities"
                  :media-statuses="mediaStatuses"
                  class="ma-3"
                  @deleteMedia="deleteMedia"
              >
              </amb-media-card>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="d-flex flex-wrap align-start mb-6">
              <amb-media-card
                  v-for="image in poiRel.images"
                  :key="image.id"
                  :media="image"
                  :poi-status="poiRel.status"
                  :media-priorities="imagePriorities"
                  :media-statuses="mediaStatuses"
                  class="ma-3"
                  @deleteMedia="deleteMedia"
              >
              </amb-media-card>
            </div>
          </v-tab-item>
        </v-tabs-items>

        <div class="d-flex justify-center">
          <v-btn
            color="primary"
            @click="changeStatus($constants.AMB_POI_STATUSES.FOR_EDITOR)"
            v-if="poiRel.status === $constants.AMB_POI_STATUSES.IN_REVIEW">
            Send to edit
          </v-btn>
          <v-btn
            color="green"
            @click="changeStatus($constants.AMB_POI_STATUSES.DONE)"
            v-if="poiRel.status === $constants.AMB_POI_STATUSES.UPLOADED">
            Mark as done
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex';
import AmbStatusIcon from '../../components/AmbStatusIcon.vue';
import GoogleMapMarkers from '../../components/GoogleMapMarkers.vue';
import AmbMediaCard from '../../components/AmbMediaCard.vue';

export default {
  name: 'AmbassadorPoi',
  components: {
    AmbMediaCard,
    GoogleMapMarkers,
    AmbStatusIcon,
  },
  data: () => ({
    pageTab: null,
    poiRel: {},
    newImages: [],
    poiMarkersDialog: {
      show: false,
      loading: false,
    },
    statuses: [],
    mediaStatuses: [],
    videoPriorities: [],
    imagePriorities: [],
  }),

  mounted() {
    this.$requestHelpers.get(`api/admin/ambassador/poi-info/${this.$route.params.id}`)
      .then((response) => {
        this.poiRel = response.data.result;
        this.newImages = this.poiRel.images.filter((e) => !e.admin_viewed);
      });

    this.$requestHelpers
      .get('api/admin/ambassador/poi/statuses')
      .then((response) => {
        this.statuses = response.data.result;
      });

    this.$requestHelpers
      .get('api/admin/ambassador/media/media-statuses')
      .then((response) => {
        this.mediaStatuses = response.data.result;
      });

    this.$requestHelpers
      .get('api/admin/video/getVideoPriorities')
      .then((response) => {
        this.videoPriorities = response.data;
        this.videoPriorities.unshift({ id: '', name: 'Empty' });
      });

    // TODO change to get from backend
    this.imagePriorities = [
      { id: 0, name: 'GeoTag Preview' },
      { id: 1, name: 'Priority 1' },
      { id: 2, name: 'Priority 2' },
      { id: 3, name: 'Priority 3' },
    ];

    this.listenUpdateVideo();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    listenUpdateVideo() {
      this.$websocket.Echo().private('AdminAmbMediaUpdate')
        .listen('.update-amb-media', (event) => {
          if (event.ambMedia) {
            const index = this.poiRel.videos.findIndex((e) => e.id === event.ambMedia.id);
            if (index > -1) {
              Object.assign(this.poiRel.videos[index], event.ambMedia);
            }
          }
        });
    },

    changeStatus(status) {
      this.$requestHelpers
        .patch(`api/admin/ambassador-rel/${this.$route.params.id}`, {
          status,
        })
        .then((response) => {
          if (response.data.success) {
            if (response.data.result.length) {
              this.setSnack({
                color: 'red',
                text: response.data.result,
              });
            } else {
              this.$router.push({ name: 'ambassadors' });
            }
          }
        });
    },

    deleteMedia(mediaId) {
      this.$confirm('Are you sure you want to delete this media?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/ambassador/media/delete/${mediaId}`)
          .then(() => {
            this.poiRel.videos = this.poiRel.videos.filter((e) => e.id !== mediaId);
            this.poiRel.images = this.poiRel.images.filter((e) => e.id !== mediaId);
          });
      });
    },

    bulkSetAdminViewed() {
      this.newImages.forEach((image) => {
        this.$requestHelpers
          .patch(`api/admin/ambassador/media/update/${image.id}`, {
            admin_viewed: new Date().toISOString(),
          })
          .then(() => {
            this.newImages = this.newImages.filter((e) => e.id !== image.id);
          });
      });
    },
  },

  deactivated() {
    this.$websocket.Echo().private('AdminAmbMediaUpdate')
      .stopListening('.update-amb-media');

    this.$destroy();
  },
};
</script>
